<div class="flex gap-10 m-b-14 peer-connections-container">
  <mat-form-field appearance="fill">
    <mat-label>Peer Connection</mat-label>
    <mat-select (selectionChange)="onSelectionChange($event.value)" [(value)]="selectedPeer">
      <mat-option [value]="PUBLISHER_ID">Publisher</mat-option>
      @for (p of peers; track p) {
      <mat-option [value]="p.user.userId"> {{ p.user.firstName }} </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

@if (isPublishPeerSelected) {
<div class="flex flex-column m-b-16">
  <mat-slide-toggle [(ngModel)]="isQualityOverridden" (change)="onQualityOverrideToggleChange($event.checked)">
    Override Quality
  </mat-slide-toggle>
  @if (isQualityOverridden) {
  <mat-form-field appearance="fill">
    <mat-label>Presenter Video Quality</mat-label>
    <mat-select (selectionChange)="onQualityOverride($event.value)" [(value)]="overrideQuality">
      <mat-option [value]="PresenterVideoQuality.QUALITY_STANDARD">Standard</mat-option>
      <mat-option [value]="PresenterVideoQuality.QUALITY_720P">720p</mat-option>
      <mat-option [value]="PresenterVideoQuality.QUALITY_1080P">1080p</mat-option>
    </mat-select>
  </mat-form-field>
  }
  <mat-form-field appearance="fill">
    <mat-label>Codec</mat-label>
    <mat-select (selectionChange)="onCodecOverride($event.value)" [(value)]="overrideCodec">
      <mat-option [value]="VideoCodec.VP8">VP8</mat-option>
      <mat-option [value]="VideoCodec.VP9">VP9</mat-option>
      <mat-option [value]="VideoCodec.H264">H.264</mat-option>
      <mat-option [value]="VideoCodec.AV1">AV1</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Scalability Mode</mat-label>
    <mat-select (selectionChange)="onScalabilityModeOverride($event.value)" [(value)]="scalabilityMode">
      <mat-option [value]="ScalabilityMode.NONE">None</mat-option>
      <mat-option [value]="ScalabilityMode.L1T1">L1T1</mat-option>
      <mat-option [value]="ScalabilityMode.L1T2">L1T2</mat-option>
      <mat-option [value]="ScalabilityMode.L1T3">L1T3</mat-option>
      <mat-option [value]="ScalabilityMode.L2T1">L2T1</mat-option>
      <mat-option [value]="ScalabilityMode.L2T2">L2T2</mat-option>
      <mat-option [value]="ScalabilityMode.L2T3">L2T3</mat-option>
      <mat-option [value]="ScalabilityMode.L3T1">L3T1</mat-option>
      <mat-option [value]="ScalabilityMode.L3T2">L3T2</mat-option>
      <mat-option [value]="ScalabilityMode.L3T3">L3T3</mat-option>
      <mat-option [value]="ScalabilityMode.L2T1h">L2T1h</mat-option>
      <mat-option [value]="ScalabilityMode.L2T2h">L2T2h</mat-option>
      <mat-option [value]="ScalabilityMode.L2T3h">L2T3h</mat-option>
      <mat-option [value]="ScalabilityMode.L3T1h">L3T1h</mat-option>
      <mat-option [value]="ScalabilityMode.L3T2h">L3T2h</mat-option>
      <mat-option [value]="ScalabilityMode.L3T3h">L3T3h</mat-option>
      <mat-option [value]="ScalabilityMode.S2T1">S2T1</mat-option>
      <mat-option [value]="ScalabilityMode.S2T2">S2T2</mat-option>
      <mat-option [value]="ScalabilityMode.S2T3">S2T3</mat-option>
      <mat-option [value]="ScalabilityMode.S2T1h">S2T1h</mat-option>
      <mat-option [value]="ScalabilityMode.S2T2h">S2T2h</mat-option>
      <mat-option [value]="ScalabilityMode.S2T3h">S2T3h</mat-option>
      <mat-option [value]="ScalabilityMode.S3T1">S3T1</mat-option>
      <mat-option [value]="ScalabilityMode.S3T2">S3T2</mat-option>
      <mat-option [value]="ScalabilityMode.S3T3">S3T3</mat-option>
      <mat-option [value]="ScalabilityMode.S3T1h">S3T1h</mat-option>
      <mat-option [value]="ScalabilityMode.S3T2h">S3T2h</mat-option>
      <mat-option [value]="ScalabilityMode.S3T3h">S3T3h</mat-option>
      <mat-option [value]="ScalabilityMode.L2T2_KEY">L2T2_KEY</mat-option>
      <mat-option [value]="ScalabilityMode.L2T2_KEY_SHIFT">L2T2_KEY_SHIFT</mat-option>
      <mat-option [value]="ScalabilityMode.L2T3_KEY">L2T3_KEY</mat-option>
      <mat-option [value]="ScalabilityMode.L2T3_KEY_SHIFT">L2T3_KEY_SHIFT</mat-option>
      <mat-option [value]="ScalabilityMode.L3T1_KEY">L3T1_KEY</mat-option>
      <mat-option [value]="ScalabilityMode.L3T2_KEY">L3T2_KEY</mat-option>
      <mat-option [value]="ScalabilityMode.L3T2_KEY_SHIFT">L3T2_KEY_SHIFT</mat-option>
      <mat-option [value]="ScalabilityMode.L3T3_KEY">L3T3_KEY</mat-option>
      <mat-option [value]="ScalabilityMode.L3T3_KEY_SHIFT">L3T3_KEY_SHIFT</mat-option>
    </mat-select>
  </mat-form-field>
</div>
} @if (!isPublishPeerSelected) {
<div class="flex flex-column m-b-16">
  <mat-form-field appearance="fill">
    <mat-label>Temporal Layer</mat-label>
    <mat-select (selectionChange)="onTemporalLayerChange($event.value)" [(value)]="temporalLayer">
      <mat-option [value]="0">0</mat-option>
      <mat-option [value]="1">1</mat-option>
      <mat-option [value]="2">2</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Spatial Layer</mat-label>
    <mat-select (selectionChange)="onSpatialLayerChange($event.value)" [(value)]="spatialLayer">
      <mat-option [value]="0">0</mat-option>
      <mat-option [value]="1">1</mat-option>
      <mat-option [value]="2">2</mat-option>
    </mat-select>
  </mat-form-field>
</div>
} @if (peerStats) {
<div class="flex flex-column peer-debugger-container">
  <span class="uppercase weight-bold font-s"> Timestamp: {{ peerStats.timestamp | date:'mediumTime'}} </span>
  <!-- Peer Connection -->
  <div class="m-b-8">
    <div class="uppercase weight-bold font-s">Peer Connection</div>
    <div class="text-overflow-ellipsis">Connection State: {{ statsPeerConnection?.connectionState }}</div>
    <div class="text-overflow-ellipsis">Ice Connection State: {{ statsPeerConnection?.iceConnectionState }}</div>
    <div class="text-overflow-ellipsis">Signaling State: {{ statsPeerConnection?.signalingState }}</div>
  </div>
  <!-- Inbound -->
  @if (!isPublishPeerSelected) {
  <div class="m-b-8">
    <div class="uppercase weight-bold font-s">Inbound</div>
    <div class="text-overflow-ellipsis">
      Packets Received: <span class="font-s">{{peerStats.packetsReceived }}</span>
    </div>
    <div class="text-overflow-ellipsis">Bytes Received: {{ peerStats.bytesReceived | filesize }}</div>
    <div class="text-overflow-ellipsis">Packets Lost: {{ peerStats.packetsLost }}</div>
  </div>
  }
  <!-- Outbound -->
  @if (isPublishPeerSelected) {
  <div class="m-b-8">
    <div class="uppercase weight-bold font-s">Outbound</div>
    <div class="text-overflow-ellipsis">Packets Sent: {{ peerStats.packetsSent }}</div>
    <div class="text-overflow-ellipsis">Bytes Sent: {{ peerStats.bytesSent | filesize }}</div>
  </div>
  }
  <!-- Audio-->
  @if (!isPublishPeerSelected) {
  <div class="m-b-8">
    <div class="uppercase weight-bold font-s">Audio</div>
    <div class="text-overflow-ellipsis">Jitter: {{ peerStats.audioJitter }}</div>
    <div class="text-overflow-ellipsis">Jitter Buffer Delay: {{ peerStats.audioJitterBufferDelay }}</div>
    <div class="text-overflow-ellipsis">Packets Lost: {{ peerStats.audioPacketsLost }}</div>
  </div>
  }
  <!-- Video -->
  <div class="m-b-8">
    <div class="uppercase weight-bold font-s">Video</div>
    @if (isPublishPeerSelected) {
    <div class="text-overflow-ellipsis">HD Presenter Enabled: {{ hdPresenterFlag }}</div>
    <div class="text-overflow-ellipsis">Target Bitrate: {{ peerStats.targetBitrate | bitrate}}</div>
    <div class="text-overflow-ellipsis">Configured Bitrate: {{ publishBitrate | bitrate }}</div>
    <div class="text-overflow-ellipsis">Frame Height: {{ peerStats.frameHeight }}</div>
    <div class="text-overflow-ellipsis">Frame Width: {{ peerStats.frameWidth }}</div>
    <div class="text-overflow-ellipsis">Frames Per Second: {{ peerStats.framesPerSecond }}</div>
    <div class="text-overflow-ellipsis">
      Quality Limitation Reason: {{ peerStats.outboundQLR }}, Duration: {{ peerStats.limitationDuration}}
    </div>
    <div class="text-overflow-ellipsis">Frames Sent: {{ peerStats.framesSent }}</div>
    <div class="text-overflow-ellipsis">Nack Count: {{ peerStats.nackCount}}</div>
    <div class="text-overflow-ellipsis">FIR Count: {{ peerStats.firCount}}</div>
    <div class="text-overflow-ellipsis">PLI Count: {{ peerStats.pliCount}}</div>
    } @if (!isPublishPeerSelected) {
    <div class="text-overflow-ellipsis">Frames Received: {{ peerStats.framesReceived }}</div>
    <div class="text-overflow-ellipsis">Frames Dropped: {{ peerStats.framesDropped }}</div>
    <div class="text-overflow-ellipsis">Frame Height: {{ peerStats.frameHeight }}</div>
    <div class="text-overflow-ellipsis">Frame Width: {{ peerStats.frameWidth }}</div>
    <div class="text-overflow-ellipsis">Frames Per Second: {{ peerStats.framesPerSecond }}</div>
    <div class="text-overflow-ellipsis">Target Bitrate: {{ peerStats.targetBitrate | bitrate}}</div>
    <div class="text-overflow-ellipsis">Jitter: {{ peerStats.videoJitter }}</div>
    <div class="text-overflow-ellipsis">Jitter Buffer Delay: {{ peerStats.videoJitterBufferDelay }}</div>
    <div class="text-overflow-ellipsis">Packets Lost: {{ peerStats.videoPacketsLost }}</div>
    }
  </div>
</div>
}
